import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, OverlayTrigger, Popover } from "react-bootstrap";
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import SkipButton from "./SkipButton";
import getNextPage from "./getNextPage";
import { RouterContext } from "./Onboarding";

export default function CompanyType(props) {
  const route = useContext(RouterContext);

  const nextPage = getNextPage(props.onboarding_progress);
  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);
  let eCommerce = require("images/onboarding/cart.png");
  eCommerce = <img className="py-4" src={`/datapulse${eCommerce}`} />;
  let leadGen = require("images/onboarding/profileicon.png");
  leadGen = <img className="py-4" src={`/datapulse${leadGen}`} />;

  props.pageLocator();

  const [validated, setValidated] = useState(false);

  useEffect(() => {
    const form = document.getElementById("onboarding-form");
    if (ecommerce || lead) {
      setValidated(true);
    } else {
      setValidated(false);
    }
  });

  const [ecommerce, setEcommerce] = useState(props.accountType == 0 ? true : false);

  const [lead, setLead] = useState(props.accountType == 1 ? true : false);

  const changeOption = (option) => {
    if (option === 1 && lead === true) {
      setLead(false);
      props.setAccountType("");
    }
    if (option === 1 && lead === false) {
      setLead(true);
      setEcommerce(false);
      props.setAccountType(1);
    }
    if (option === 0 && ecommerce === true) {
      setEcommerce(false);
      props.setAccountType("");
    }
    if (option === 0 && ecommerce === false) {
      setLead(false);
      setEcommerce(true);
      props.setAccountType(0);
    }
  };

  return (
    <>
      <Row className=" mb-4 justify-content-center">
        <Col className="text-center">
          <p className="visby-bold f28 primary">What type of company is this?</p>
        </Col>
      </Row>

      <Row style={{ marginBottom: "70px" }} className="justify-content-center">
        <Col className="text-center">
          <Button onClick={() => changeOption(0)} className={ecommerce ? "type-active d-inline-block" : "choose-box d-inline-block"}>
            <div className="pt-3">{eCommerce}</div>
            <div>
              <p className="f24 py-2 visby-medium primary">Ecommerce</p>
            </div>
          </Button>

          <Button onClick={() => changeOption(1)} className={lead ? "type-active d-inline-block" : "choose-box d-inline-block"}>
            <div className="pt-3">{leadGen}</div>
            <div>
              <p className="f24 py-2 visby-medium primary">Lead Gen</p>
            </div>
          </Button>
          <div className="company-type-explanation">
            <div className="pb-3 diff-box">
              <span className="f22 visby-bold primary">
                <i className="far f24 pr-3 fa-question-circle"></i>
                <span>What's the difference?</span>
              </span>
            </div>
            <div className="ml-2 expl-box">
              <div className="company-type-top">
                <p className={ecommerce ? "f14 nunito-regular light-primary bold" : "f14 nunito-regular light-primary"}>
                  Ecommerce clients are those that are <br></br>tracking revenue and measuring return on <br></br> ad spend.
                </p>
              </div>
              <div className="company-type-bot">
                <p className={lead ? "f14 nunito-regular light-primary bold" : "f14 nunito-regular light-primary"}>
                  Lead generation clients are those that are <br></br> NOT tracking revenue and are measuring <br></br> leads & cost per acquisition.
                </p>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`One option must be selected`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
